export default "__VITE_ASSET__C3fF9Dem__"